import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import ExpenseBillForm from './forms/expense-bill-form';


// Component
export default class EditExpenseBill extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    // Save the initial form values in the state on mount, because we don't want
    // to reinitialize the form if something about the PO changes while we're editing
    // it (like when it gets set to syncing while saving to the api)
    this.setState({ initialFormValues: getInitialFormValues(_.cloneDeep(this.props.expenseBill)) });
  }

  render() {
    const { afterSubmit, cancel, ...props } = this.props;

    return (
      <ExpenseBillForm
        {...props}
        cancel={this.props.cancel}
        initialValues={this.state.initialFormValues}
        onSubmit={(values) =>
          ExpenseBill.update(formatExpenseBill(values))
            .then(() => PurchaseOrder.findOne(values.purchaseOrderId, PurchaseOrder.defaultQuery))
            .then(afterSubmit)
            .then(cancel)
            .catch(alerts.catchError)
        }
      />
    );
  }
}

EditExpenseBill.propTypes = {
  cancel: PropTypes.func.isRequired,
  expenseBill: PropTypes.object.isRequired,
  afterSubmit: PropTypes.func.isRequired
};


// Helper functions
function formatExpenseBill(data) {
  const lineItems = _.map(data.lineItems, (lineItem) => {
    if (Number(lineItem.quantity) <= 0) return { id: lineItem.id, status: 'Archived' };
    return lineItem;
  });
  const lineItemTotal = _.sum(_.map(lineItems, (lineItem) => lineItem.quantity * lineItem.unitCost));

  return {
    id: data.id,
    purchaseOrder: data.purchaseOrderId,
    date: data.date || moment().toDate(),
    shipping: data.shipping || 0,
    tax: data.tax || 0,
    amount: lineItemTotal + Number(data.shipping || 0) + Number(data.tax || 0),
    lineItems,
    receipt: data.receipt
  };
}

function getInitialFormValues(expenseBill) {
  return {
    ...expenseBill,
    shipping: expenseBill.shipping || 0,
    purchaseOrderId: expenseBill.purchaseOrder,
    receipt: [{ name: expenseBill.receipt.filename }],
    lineItems: _.map(expenseBill.lineItems, (lineItem) => ({
      ...lineItem,
      description: lineItem.purchaseOrderLineItem.description,
      billableQuantity: lineItem.purchaseOrderLineItem.unbilledQuantity + lineItem.quantity
    }))
  };
}
